import Vue from 'vue'
import Router from 'vue-router'

import beforeEach from './guards/beforeEach'
import routes from './routes'
import scrollBehavior from './scrollBehavior'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-exact-active',
  scrollBehavior,
  routes
})

router.beforeEach(beforeEach)

export default router
